import { Box } from '@material-ui/core';

import { TotalLine } from '@/components/modules/_shared/CartSummary/components/CartTotalLine';
import { CartSummaryData } from '@/components/modules/_shared/CartSummary/types/CartSummaryData';

interface ApplicationSummaryCartTotalsProps {
  cartSummaryData: CartSummaryData;
  strikethrough?: boolean;
}

export const CartSummaryTotals = ({ cartSummaryData, strikethrough }: ApplicationSummaryCartTotalsProps) => {
  if (!cartSummaryData) return null;

  //const totalVat = cartSummaryData.totalVat;
  //const subTotal = cartSummaryData.total - totalVat;

  return (
    <Box display={'flex'} flexDirection={'column'} gridGap={4}>
      {/*<TotalLine label={'SUBTOTAL'} value={subTotal} currency={cartSummaryData.currency} />
      <TotalLine
        label={'VAT'}
        labelSuffix={` (${formatPercent(totalVat / subTotal, 0)})`}
        value={totalVat}
        currency={cartSummaryData.currency}
      />*/}
      <TotalLine
        strong
        label={'TOTAL'}
        value={cartSummaryData.total}
        currency={cartSummaryData.currency}
        strikethrough={strikethrough}
      />
    </Box>
  );
};
